module.exports = __webpack_public_path__ + "img/real_time-small.ae7aea08.png";